
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { useBadgeCount } from './useBadgeCount';
import { NavItem } from './types';
import { useNavItemPathMatching } from './hooks/useNavItemPathMatching';

type SimpleNavItemProps = {
  item: NavItem;
  expanded: boolean;
  isMobile: boolean;
  handleNavigation: () => void;
};

const SimpleNavItem = ({ 
  item, 
  expanded, 
  isMobile, 
  handleNavigation 
}: SimpleNavItemProps) => {
  const Icon = item.icon;
  const badgeCount = useBadgeCount(item.title);
  const location = useLocation();
  const isActive = useNavItemPathMatching(item.path, location.pathname);

  // Determine if this should be an exact match
  const shouldUseEnd = item.path === '/app/dashboard' || item.path === '/dashboard' || item.path === '/' || item.path === '/app/leads';

  return (
    <NavLink 
      to={item.path} 
      className={cn(
        "flex items-center px-3 py-2.5 rounded-md transition-all duration-200 group relative",
        isActive 
          ? "bg-primary/10 text-primary font-medium" 
          : "text-muted-foreground hover:bg-muted hover:text-foreground",
        !expanded && !isMobile && "justify-center"
      )}
      onClick={handleNavigation}
      end={shouldUseEnd}
    >
      <Icon size={20} className={cn("flex-shrink-0", expanded || isMobile ? "mr-3" : "")} />
      {(expanded || isMobile) && <span>{item.title}</span>}
      {badgeCount !== null && badgeCount > 0 && (
        expanded || isMobile 
          ? <Badge variant="default" size="xs" className="ml-auto rounded-full text-[9px] h-4 min-w-4 flex items-center justify-center px-1">{badgeCount}</Badge>
          : <Badge variant="default" size="xs" className="absolute -top-0.5 -right-0 rounded-full text-[8px] h-3.5 min-w-3.5 flex items-center justify-center p-0">{badgeCount}</Badge>
      )}
    </NavLink>
  );
};

export default SimpleNavItem;
